var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['sol-item animated u-flex', _vm.type == 'left' ? 'slideInLeft' : 'slideInRight' ]},[_c('div',{staticClass:"sol-icon"}),_vm._v(" "),_c('div',[_c('p',{staticClass:"sol-item-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"sol-item-msg"},[_vm._v(_vm._s(_vm.content))]),_vm._v(" "),_vm._t("content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36213f82","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/solItem.vue
// module id = null
// module chunks = 